
'use strict';


export function  primaLettaraMaiuscola (str) {
     return str.substring(0,1).toUpperCase() +str.substring(1).toLowerCase()
 }

 export function convertDate(inputFormat) {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/')
  }


  export const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  export function downloadFileBase64(contentBase64, contentType, fileName) {
    var blob = b64toBlob(contentBase64,contentType);
    downloadFile(blob, fileName);

  }

  export function downloadFile(blob, fileName) {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
      window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else { // for Non-IE (chrome, firefox etc.)
      var a = document.createElement("a");
      document.body.appendChild(a);                    
      var url = URL.createObjectURL(blob);
      a.href =  url;
      a.download = fileName;
      a.target="_blank"
      a.click();
      URL.revokeObjectURL(a.href)
      a.remove();
  }
}

  export function downloadFile1(content, contentType, fileName) {
    var csvData = b64toBlob(content,contentType);
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
        window.navigator.msSaveOrOpenBlob(csvData, fileName);
    } else { // for Non-IE (chrome, firefox etc.)
        var a = document.createElement("a");
        document.body.appendChild(a);                    
        var csvUrl = URL.createObjectURL(csvData);
        a.href =  csvUrl;
        a.download = fileName;
        a.target="_blank"
        a.click();
        URL.revokeObjectURL(a.href)
        a.remove();
    }
}

export function getTarget(e) {
  var targ;

  if (!e) {
      e = event;
  }

  if (e.target) {
      targ = e.target;
  } else if (e.srcElement) {
      targ = e.srcElement;
  }

  if (targ.nodeType == 3) { // defeat Safari bug
      targ = targ.parentNode;
  }

  return targ;
}


export function convertBase64 (file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file)
    fileReader.onload = () => {
      resolve(fileReader.result);
    }
    fileReader.onerror = (error) => {
      reject(error);
    }
  })
}